export function ExclamationIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM9 11C9 11.5523 9.4477 12 10 12C10.5523 12 11 11.5523 11 11V6C11 5.44772 10.5523 5 10 5C9.4477 5 9 5.44772 9 6V11ZM11 13.9888C11 13.4365 10.5523 12.9888 10 12.9888C9.4477 12.9888 9 13.4365 9 13.9888V14C9 14.5523 9.4477 15 10 15C10.5523 15 11 14.5523 11 14V13.9888Z"
                fill="#FB923C"
            />
        </svg>
    )
}
